import { createLucideIcon } from 'lucide-react';
export const ChevronRight = createLucideIcon('chevron-right', [
  [
    'path',
    {
      d: 'M8 5L15 12L8 19',
      key: 'i7g0lp',
    },
  ],
]);
